module.exports = __webpack_public_path__ + "img/process_small@2x.02a85407.webp";